import React from 'react';

const ProgressBar = ({ completed, height = "10px" }) => {

  // 🎨 Логика для определения цвета
  const getDynamicColor = () => {
    if (completed < 33) {
      return "#4caf4f72"; // Зеленый
    }
    if (completed >= 33 && completed < 66) {
      return "#ff99007d"; // Оранжевый
    }
    // Для 66% и выше
    return "#f443367f"; // Красный
  };

  // Стили для контейнера
  const containerStyles = {
    height: height,
    width: '100%',
    backgroundColor: "#e0e0de82",
    //margin: "20px 0", // Немного отступа для наглядности
    // borderRadius: 50, // <-- Убрали
  };

  // Стили для заполнителя
  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: getDynamicColor(), // <-- Вызываем нашу функцию
    // borderRadius: 'inherit', // <-- Убрали
    transition: 'width 0.5s ease-in-out',
  };

  return (
    <div style={containerStyles}>
      {/* Внутренний div теперь пустой, 
        так как подпись не нужна 
      */}
      <div style={fillerStyles}></div>
    </div>
  );
};

export default ProgressBar;